module.exports = __webpack_public_path__ + "static/media/logo.486cfcc5.png";